<h1 matDialogTitle>Warning</h1>
<div matDialogContent class="flex flex-col">
  <p *ngIf="noConflicts; else conflictList" [testId]="testIds.NO_CONFLICTS_MESSAGE">
    There are no direct conflicts with this booking, however other items or
    products from this category are booked / hired on similar dates.
  </p>
  <ng-template #conflictList>
    <p [testId]="testIds.CONFLICTS_MESSAGE"> The following have been detected as conflicting with this item:
    </p>
  </ng-template>
  <div *ngFor="let conflict of conflicts$ | async" class="flex flex-col my-8">
    <ng-container *ngIf="conflict.conflictable_type === 'hireItem'">
      <div class="flex flex-col md:flex-row justify-start md:justify-between md:items-center items-start"
        [testId]="testIds.CONFLICT_LIST_ITEM">
        <h3 *ngIf="data.type === 'bookingItem'; else linkToBookingConflicts">
          <a [routerLink]="['docket', conflict.source.id]" target="_blank"
            class="flex flex-row justify-center items-center">
            {{ conflict.source | documentTitle : 'docket' }}
            <mat-icon>open_in_new</mat-icon>
          </a>
        </h3>
        <ng-template #linkToBookingConflicts>
          <h3>
            <a [routerLink]="['bookings/view/', conflict.booking_id]" target="_blank"
              class="flex flex-row justify-center items-center">
              Booking {{ conflict.booking_id }}
              <mat-icon>open_in_new</mat-icon>
            </a>
          </h3>
        </ng-template>

        <p>
          {{ conflict.sourceLineItem.item.code }} -
          {{ conflict.sourceLineItem.item.product.name }}
        </p>
      </div>
      <p>
        <em>{{ conflict.reason }}</em>
      </p>
    </ng-container>
    <ng-container *ngIf="conflict.conflictable_type === 'bookingItem'">
      <div class="flex flex-col md:flex-row justify-start md:justify-between md:items-center items-start"
        [testId]="testIds.CONFLICT_LIST_ITEM">
        <h3>
          <a class="flex flex-row justify-center items-center" target="_blank"
            [routerLink]="['bookings/view', conflict.source.id]">
            {{ conflict.source | documentTitle : 'booking' }}
            <mat-icon>open_in_new</mat-icon>
          </a>
        </h3>
        <p>{{ conflict.sourceLineItem | bookingItemName }}</p>
      </div>
      <p>
        <em>{{ conflict.reason }}</em>
      </p>
    </ng-container>
  </div>
  <div *ngIf="availability$ | async as availabilities" [testId]="testIds.AVAILABILITY_STATS_CONTAINER">
    <app-item-availability-stats *ngFor="let availability of availabilities; let i = index" [item]="availability.item"
      [category]="availability.category" [product]="availability.product"
      [testId]="testIds.AVAILABILITY_STATS + '-' + i"></app-item-availability-stats>
  </div>
</div>
<div matDialogActions align="end">
  <button [testId]="testIds.CLOSE_DIALOG_BUTTON" mat-button mat-dialog-close>
    Close
  </button>
</div>